import { API } from "@swivl-mono/api-helper";
import { APIErrorNames, APIServiceConfigInterface } from "@swivl-mono/types";
import * as ReactDOM from "react-dom/client";

import App from "./App/App";
import { installStaleBundleGuard } from "./Helpers/StaleBundle/staleBundleGuard";
import AccountModel from "./Models/Account/AccountModel";
import { Member } from "./Models/Member/Member.Current";
import "./datadog";
import "./styles.css";

// A tab that outlives a deploy must reload for the new build instead of going blank
// on its next lazy route (ENG-3523). Installed before anything can lazy-load.
installStaleBundleGuard(window);

const serverConfig: APIServiceConfigInterface = {
  url: import.meta.env.VITE_SERVER_URL,

  authCallBack: () => {
    return Member.jwt ? Member.jwt : "";
  },
  tokenType: "member",
  errorCallback: (e) => {
    if (e.message === APIErrorNames.INVALID_TOKEN_EXPIRED) {
      AccountModel.logOut();
    }
    throw new Error(e.message);
  }
};

const syncServerConfig: APIServiceConfigInterface = {
  url: import.meta.env.VITE_SYNC_SERVER_URL,
  authCallBack: () => {
    return Member.jwt ? Member.jwt : "";
  },
  tokenType: "member",
  errorCallback: (e) => {
    if (e.message === APIErrorNames.INVALID_TOKEN_EXPIRED) {
      AccountModel.logOut();
    }
    throw new Error(e.message);
  }
};
const bullServerConfig: APIServiceConfigInterface = {
  url: import.meta.env.VITE_BULL_SERVER_URL,
  authCallBack: () => import.meta.env.VITE_API_TOKEN,
  errorCallback: (e) => {
    throw new Error(e.message);
  }
};

const botServerConfig: APIServiceConfigInterface = {
  url: import.meta.env.VITE_BOT_SERVER_URL || "http://localhost:4444",
  authCallBack: () => import.meta.env.VITE_API_TOKEN,
  errorCallback: (e) => {
    throw new Error(e.message);
  }
};

// const notificationsServerConfig: APIServiceConfigInterface = {
//   url: import.meta.env.VITE_NOTIFICATIONS_SERVER_URL,
//   authCallBack: () => {
//     return Member.jwt ? Member.jwt : '';
//   },
//   errorCallback: (e) => {
//     if (e.message === APIErrorNames.INVALID_TOKEN_EXPIRED) {
//       AccountModel.logOut();
//     }
//     throw new Error(e.message);
//   },
// };
API.init({ Server: serverConfig, Bull: bullServerConfig, Sync: syncServerConfig, Bot: botServerConfig });

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<App />);
